import { Box, Button } from "@mui/material";
import Select from "components/ui/select";
import { useFormik } from "formik";
import * as yup from "yup";
import getInitialvalues from "../../utils/filterInitialValues";
const statuses = [
  { id: "paid", name: "Paid" },
  { id: "unpaid", name: "Unpaid" },
  { id: "partial", name: "Partial" },
  { id: "cancelled", name: "Cancelled" },
  { id: "unsent", name: "Unsent" },
];

const MainScreenFilter = ({
  currencies,
  setReload,
  setFilters,
  setPagination,
  pagination,
  filters,
  isFiltering,
  customers,
  projects,
  universities,
  intakes,
  references,
  applyThroughs,
  branches,
}) => {
  const initialValues = getInitialvalues(filters);

  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
  };

  return (
    <Box
      p="15px 20px 5px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr",
        gap: "18px",
      }}
    >
      <Select
        options={statuses}
        label="Status"
        name="status"
        selectProps={{ id: "id", label: "name" }}
        formik={formik}
      />
      <Select
        options={applyThroughs}
        label="Apply Through"
        value={formik?.values?.apply_through_id}
        onChange={(value) => formik.setFieldValue("apply_through_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />

      <Select
        options={projects}
        label="Project"
        name="project_id"
        selectProps={{ id: "id", label: "name" }}
        formik={formik}
      />

      <Select
        options={universities}
        label="Universities"
        value={formik?.values?.university_id}
        onChange={(value) => formik.setFieldValue("university_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <Select
        options={intakes}
        label="Intakes"
        value={formik?.values?.intake_id}
        onChange={(value) => formik.setFieldValue("intake_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <Select
        options={references}
        label="Referencies"
        value={formik?.values?.reference_id}
        onChange={(value) => formik.setFieldValue("reference_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      {/* <DateRangeField
        label="Followup Date"
        from="followup_date_from"
        to="followup_date_to"
        formik={formik}
        key={`${reset}`}
      /> */}
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
      >
        <Button
          variant="solid"
          onClick={formik.submitForm}
          disabled={!formik.dirty}
        >
          Filter
        </Button>
        <Button
          variant="outlined"
          disabled={!isFiltering()}
          onClick={resetForm}
        >
          Reset Filter
        </Button>
      </Box>
    </Box>
  );
};

export default MainScreenFilter;
